import React from 'react';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {
  Atom,
  Plugins,
  withSystem,
  withMeta,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
  getTagOrElse,
} from '@packages/utilities/data-utils';

export default createIntegratedAtom({
  displayName: 'Optimization',
  icon: {
    type: 'Component',
    value: qualify(
      Plugins.name('Optimization'),
      iconName('OptimizationExperience')
    ),
  },
  render: Atom.createRender(
    ({
      context,
      data,
      attributes,
      classes,
      generateAttributes,
      renderChild,
    }: AtomRenderProps) => {
      const Tag = getTagOrElse(getInPojo(data, ['tag']), 'div');
      const updatedClasses = classes.push('w-optimization');

      return (
        <Tag {...generateAttributes(attributes, updatedClasses)}>
          {getChildren(data).map((child: EvaluatedNodeData) =>
            renderChild(child, context)
          )}
        </Tag>
      );
    }
  ),
  showEmpty: true,
  constraints: {
    children: [
      {
        is: ['OptimizationBase', 'OptimizationTreatment'],
        name: 'Variation',
        rule: 'RequireOnly',
      },
    ],
  },
  fields: {
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
    children: TListOfElement,
  },
});
